import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import RawDetails from '@components/rawDetails/RawDetails';
import { getProduct } from '@core/services/networkService/_product';
import { RouteParams } from '@core/services/routingService/routingService';
import { demmiRequest } from '@helpers/app.helper';
import { DemmiFS } from '@subhanhabib/demmilib';

const VendorInventoryRaw: React.FC = () => {
  const CSSBlock = 'vendor-inventory-raw';
  const { [RouteParams.PRODUCT_ID]: productID } = useParams();

  const [product, setProduct] = useState<DemmiFS.ProductWithRaw>();
  const [_, setIsLoading] = useState(false);

  useEffect(() => {
    refreshProduct();
  }, [productID]);

  const refreshProduct = () => {
    if (productID) {
      setIsLoading(true);
      demmiRequest(getProduct(productID))
        .then(f => {
          setProduct(f);
          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
    }
  };

  return <div className={`${CSSBlock}`}>{product && <RawDetails data={product.raw} />}</div>;
};

export default VendorInventoryRaw;
